import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Box from 'ui-box';
import AntdAlertErrorBoundary from '../../components/common/AntdAlertErrorBoundary';
import MobileHeader from '../../components/mobile/Header';
import PersonalInfoScreen from '../../pages/mobile/sign-up/guest/PersonalInfoScreen';
import AccountInfoScreen from '../../pages/mobile/sign-up/guest/AccountInfoScreen';

function MobileSignupLayout() {

  return (
    <>
      <Box position="relative" height="100%">
        <AntdAlertErrorBoundary>
          <MobileHeader />
        </AntdAlertErrorBoundary>
        <AntdAlertErrorBoundary>
          <Box paddingTop={24} paddingBottom={12} paddingX={20} marginBottom={40}>
            <Switch>
              <Route path="/sign-up/form/account-info">
                <AccountInfoScreen />
              </Route>
              <Route path="/sign-up/form/personal-info">
                <PersonalInfoScreen />
              </Route>
            </Switch>
          </Box>
        </AntdAlertErrorBoundary>
      </Box>
    </>
  );
}

export default MobileSignupLayout;
